/*!
 *	Template Functions
*/

(function($){

	"use strict";

	$(document).ready(function() {

		var header     = $('.header'),
			fheader    = $('.header-fixed'),
			moduleHero = $('.module-hero'),
			mobileTest;

		/* ---------------------------------------------- /*
		 * Mobile detect
		/* ---------------------------------------------- */

		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			mobileTest = true;
		} else {
			mobileTest = false;
		}

		/* ---------------------------------------------- /*
		 * Transparent navbar animation
		/* ---------------------------------------------- */

		function navbarAnimation() {
			if ( $(window).scrollTop() > 10 ) {
				header.addClass('header-small');
				$('.header-fixed').removeClass('header-semi-transparent');
			} else {
				header.removeClass('header-small');
				$('.header-fixed').addClass('header-semi-transparent');
			}
		}

		navbarAnimation();

		$(window).scroll(function() {
			navbarAnimation();
		});

		$('.js-stick').stick_in_parent();

		$('.nav-icon-toggle').on('click', function() {
			$(this).toggleClass('open');
		});

		/* ---------------------------------------------- /*
		 * One Page Nav
		/* ---------------------------------------------- */

		$('.onepage-nav').singlePageNav({
			currentClass: 'active'
		});

		/* ---------------------------------------------- /*
		 * Collapse navbar on click
		/* ---------------------------------------------- */

		$(document).on('click', '.main-nav.in', function(e) {
			if ( $(e.target).is('a') && !$(e.target).parent().hasClass('has-submenu') ) {
				$(this).collapse('hide');
				$('.nav-icon-toggle').toggleClass('open');
			}
		});

		/* ---------------------------------------------- /*
		 * FlexSlider
		/* ---------------------------------------------- */

		$('.flexslider').flexslider({
			animation: "fade",
			controlNav: false,
			prevText: '<i class="icon-arrow-left icons"></i>',
			nextText: '<i class="icon-arrow-right icons"></i>',
			before: function(slider) {
				$('.hero-caption').fadeOut().animate({top:'-80px'},{queue:false, easing: 'swing', duration: 700});
				slider.slides.eq(slider.currentSlide).delay(500);
				slider.slides.eq(slider.animatingTo).delay(500);
			},
			after: function(slider) {
				$('.hero-caption').fadeIn().animate({top:'0'},{queue:false, easing: 'swing', duration: 700});
			},
			useCSS: true
		});

		/* ---------------------------------------------- /*
		 * Setting background of modules
		/* ---------------------------------------------- */

		var modules = $('.module-hero, .module, .module-sm, .module-xs, .background-side, .footer');

		modules.each(function() {
			if ($(this).attr('data-background')) {
				$(this).css('background-image', 'url(' + $(this).attr('data-background') + ')');
			}
		});

		/* ---------------------------------------------- /*
		 * Parallax
		/* ---------------------------------------------- */

		$('.parallax').jarallax({
			speed: 0.7
		});

		/* ---------------------------------------------- /*
		 * Twitter
		/* ---------------------------------------------- */

		$('.twitter-feed').each(function (index) {
			$(this).attr('id', 'twitter-' + index);

			var twitterID      = $(this).data('twitter');
			var twitter_config = {
				'id':             twitterID,
				'domId':          'twitter-' + index,
				'maxTweets':      2,
				'enableLinks':    true,
				'showPermalinks': false
			};
			twitterFetcher.fetch(twitter_config);
		});

		/* ---------------------------------------------- /*
		 * Shop Product Zoom
		/* ---------------------------------------------- */

		$('.product-slider .item').zoom();

		/* ---------------------------------------------- /*
		 * Shop product carousel
		/* ---------------------------------------------- */

		var owl;
		owl = $('.product-slider');

		owl.owlCarousel({
			navigation: false,
			slideSpeed: 300,
			paginationSpeed: 400,
			singleItem: true,
			afterInit: afterOWLinit,
			afterUpdate: afterOWLinit,
			touchDrag: false,
			mouseDrag: false
		});

		function afterOWLinit() {
			$('.owl-controls .owl-page').append('<a class="item-link" href="#"/>');

			var pafinatorsLink = $('.owl-controls .item-link');

			$.each(this.owl.userItems, function (i) {
				$(pafinatorsLink[i]).css({
					'background': 'url(' + $(this).find('img').attr('src') + ') center center no-repeat',
					'-webkit-background-size': 'cover',
					'-moz-background-size': 'cover',
					'-o-background-size': 'cover',
					'background-size': 'cover'
				}).click(function () {
					owl.trigger('owl.goTo', i);
					return false;
				});
			});

		}

		/* ---------------------------------------------- /*
		 * Carousels & Sliders
		/* ---------------------------------------------- */

		$('.widget-slider').each(function () {
			$(this).owlCarousel($.extend({
				stopOnHover: true,
				navigation: false,
				pagination: false,
				autoPlay: 4000,
				singleItem: true,
				transitionStyle : 'fade',
				items: 1,
			}, $(this).data('carousel-options')));
		});

		/*
		$('.images-carousel').each(function () {
			$(this).owlCarousel($.extend({
				stopOnHover: true,
				navigation: false,
				pagination: true,
				autoPlay: 3000,
				items: 5,
				navigationText: [
					'<i class="fa fa-angle-left"></i>',
					'<i class="fa fa-angle-right"></i>'
				],
			}, $(this).data('carousel-options')));
		});


		/* ---------------------------------------------- /*
		 * Portfolio
		/* ---------------------------------------------- */

		var filters        = $('#filters'),
			worksgrid      = $('#works-grid'),
			worksgrid_mode = 'masonry';

		if (worksgrid.hasClass('works-grid-masonry')) {
			worksgrid_mode = 'masonry';
		} else {
			worksgrid_mode = 'fitRows';
		}

		$('a', filters).on('click', function() {
			var selector = $(this).attr('data-filter');
			$('.current', filters).removeClass('current');
			$(this).addClass('current');
			worksgrid.isotope({
				filter: selector
			});
			return false;
		}).scroll();

		$(window).on('resize', function() {
			worksgrid.imagesLoaded(function() {
				worksgrid.isotope({
					layoutMode: worksgrid_mode,
					itemSelector: '.work-item',
				});
			});
		}).resize();

		/* ---------------------------------------------- /*
		 * Blog masonry
		/* ---------------------------------------------- */

		$(window).on('resize', function() {
			setTimeout( function() {
				$('.post-masonry').masonry();
			}, 1000);
		}).resize();

		/* ---------------------------------------------- /*
		 * Progress bars, counters animations
		/* ---------------------------------------------- */

		$('.progress-bar').each(function() {
			$(this).appear(function() {
				var percent = $(this).attr('aria-valuenow');
				$(this).animate({'width' : percent + '%'});
				$(this).parent('.progress').prev('.progress-title').find('span span').countTo({
					from: 0,
					to: percent,
					speed: 900,
					refreshInterval: 30
				});
			});
		});

		$('.counter-timer').each(function() {
			$(this).appear(function() {
				var number = $(this).attr('data-to');
				$(this).countTo({
					from: 0,
					to: number,
					speed: 1500,
					refreshInterval: 10,
					formatter: function (number, options) {
						number = number.toFixed(options.decimals);
						number = number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
						return number;
					}
				});

			});
		});

		/* ---------------------------------------------- /*
		 * Lightbox, Gallery
		/* ---------------------------------------------- */

		baguetteBox.run('.qlightbox', {
			captions: true,
			buttons: 'auto',
			fullScreen: false,
			noScrollbars: false,
			titleTag: false,
			async: false,
			preload: 2,
			animation: 'slideIn',
			afterShow: null,
			afterHide: null,
			onChange: null,
			overlayBackgroundColor:	'rgba (0,0,0,.8)'
		});

		$('.video-pop-up').magnificPopup({
			type: 'iframe',
		});

		/* ---------------------------------------------- /*
		 * A jQuery plugin for fluid width video embeds
		/* ---------------------------------------------- */

		$('body').fitVids();

		/* ---------------------------------------------- /*
		 * WOW Animation
		/* ---------------------------------------------- */

		var wow = new WOW({
			mobile: false
		});
		wow.init();


		/* ---------------------------------------------- /*
		 * Tooltips
		/* ---------------------------------------------- */

		$(function () {
			$('[data-toggle="tooltip"]').tooltip({
				trigger: 'hover'
			})
		})

		/* ---------------------------------------------- /*
		 * Scroll Animation
		/* ---------------------------------------------- */

		$('.smoothscroll').on('click', function(e) {
			var target  = this.hash;
			var $target = $(target);

			$('html, body').stop().animate({
				'scrollTop': $target.offset().top - header.height()
			}, 600, 'swing');

			e.preventDefault();
		});

		/* ---------------------------------------------- /*
		 * Scroll top
		/* ---------------------------------------------- */

		$('a[href="#top"]').on('click', function() {
			$('html, body').animate({ scrollTop: 0 }, 'slow');
			return false;
		});

		/* ---------------------------------------------- /*
		 * Disable hover on scroll
		/* ---------------------------------------------- */

		var body = document.body,
			timer;
		window.addEventListener('scroll', function() {
			clearTimeout(timer);
			if (!body.classList.contains('disable-hover')) {
				body.classList.add('disable-hover')
			}
			timer = setTimeout(function() {
				body.classList.remove('disable-hover')
			}, 100);
		}, false);

	});

})(jQuery);
